module.exports = __webpack_public_path__ + "img/interreg-logo.fa05a965.png";